import { Editor, Node, Path, Element as SlateElement, Transforms } from 'slate'

import { BLOCK_FORMATS, TCustomElement } from '../../interface/custom-types'

export const removeExpandBlock = (editor: Editor, parentNode: TCustomElement) => {
  if (editor.selection) {
    const previousNodePath = Editor.before(editor, editor.selection?.anchor.path)
    if (previousNodePath) {
      const previousNodeParent = Node.get(editor, Path.parent(previousNodePath.path))
      if (
        SlateElement.isElement(previousNodeParent) &&
        previousNodeParent.type === BLOCK_FORMATS.expandBlockTitle
      ) {
        Transforms.select(editor, Path.parent(previousNodePath.path))
        Transforms.collapse(editor, { edge: 'end' })

        return true
      }
    }
  }

  const [expandBlock] = Editor.nodes(editor, {
    match: (node) => SlateElement.isElement(node) && node.type === BLOCK_FORMATS.expandBlock,
    mode: 'lowest', // search nearest node
  })

  if (expandBlock && parentNode.type === BLOCK_FORMATS.expandBlockTitle) {
    if (parentNode.children.some((item) => item.text === '')) {
      Transforms.removeNodes(editor, { at: expandBlock[1] })

      return true
    }
  }

  return false
}
